export const CornerRadii = {
  "radius-1": "4px",
  "radius-2": "8px",
  "radius-3": "12px",
  "radius-4": "16px",
  "radius-round": "100px"
};
